module.exports = __webpack_public_path__ + "static/img/app_payment_link.42a8a4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/app_payment_link.png
// module id = yP0J
// module chunks = 8